import React from 'react';
import env from '@/env';
import { getQuery } from '@/common/utils';
import { goto } from '@/common/goto';
import Microapp from '@/components/micro-app';
import Container from '@/components/container';
import apis from './../apis';
import './index.less';

/*****************
 * 品店策略 - 商品策略 -  触达配置【第二步：素材触达范围设置】 *
 * 品店策略 - 商品策略 -  【触达记录的回显第三个tab也用的这个页面】(此时disable为true不可编辑) *
 *****************/
export const StrategyRangeSetExtraHeaderProps = {
  backIcon: false,
  background:
    '#f5fbff url(//img30.360buyimg.com/pop/jfs/t1/94046/35/20488/11573/61d4310eEea40992d/c19a3c48ba28c35c.png) right bottom/325px no-repeat',
  btns: undefined,
};

const DailyGoodsStrategyRangeSet = (props) => {
  const { disable: propsDisable } = props;
  let disable = propsDisable || getQuery('disable');
  disable = disable === true || disable === 'true' ? true : false;

  const activityId = getQuery('activityId');
  const jobId = getQuery('jobId'); //策略ID
  const noticeScope = 1;

  /* ************************************
   ************** 第三方通讯 *************
   ************************************ */
  // 1、素材维护消息触达（确认触达）--- 方法名：confirmSelection----返回：promise 【.then是个布尔值，true已经触达成功，false没有触达成功】
  // 2、返回上一级--- 方法名：backUp----无返回直接回调页面上一级
  // 3、你那边触达的成功给我的回调--- 方法名：touchSuccess【暂时这个函数无需返回参数】
  /**
   * data:{ noticeScope: 通知范围	(0-全量触达；1-部分触达)}
   * 决定跳转的地址，全量触达跳列表，部分触达跳商运
   * */
  function confirmSelection() {
    return apis.confirmSelection({ activityId: activityId, strategyId: jobId, noticeScope }).then((res) => {
      if (res.ret === '0') {
        return Promise.resolve({ data: res?.data?.data || false, msg: res?.msg || '数据异常,请您稍后重试！' });
      } else {
        return Promise.reject({ data: res?.data?.data || false, msg: res?.msg || '数据异常,请您稍后重试！' });
      }
    });
  }

  /**
   * 返回上一级--- 方法名：backUp----无返回回调,直接页面上一级
   * */
  function backUp() {
    history.go(-1);
  }

  /**
   * 你那边触达的成功给我的回调--- 方法名：touchSuccess【暂时这个函数无需返回参数】
   * */
  function touchSuccess() {
    const url = `/activity-manage/myCreate/daily-activities-manager/strategy?activityId=${activityId}`;
    goto(url, 'replace');
  }

  return (
    <Container>
      <div className="daily-goods-strategy-range-set-wrapper">
        {!disable ? <div className="daily-goods-strategy-range-set-title">触达商品范围设置</div> : null}
        <Microapp
          needLoading={true}
          data={{
            confirmSelection,
            backUp,
            touchSuccess,
            disable,
          }}
          name="DailyGoodsStrategyRangeSet"
          // 设置页，可编辑：https://beta-ace.jd.com/pandora/#/integration/yx-promotion?outId=xxx&activityType=11&uniqueId=xxx&ruleId=xxxx&disable=false
          // 详情页，不可编辑：https://beta-ace.jd.com/pandora/#/integration/yx-promotion?outId=xxx&activityType=11&uniqueId=xxx&ruleId=xxxx&disable=true
          url={env.ACE_DOMAIN + '/pandora/#/integration/yx-promotion'}
        />
      </div>
    </Container>
  );
};

export default DailyGoodsStrategyRangeSet;
